import React from 'react';
import { useTheme } from "@mui/material";
import { Container } from '../home/styles';
import NavBar from '../../components/navbar/navbar';
import {Grid, ListService, StyledBox, StyledTypography} from './styles';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import HandshakeIcon from '@mui/icons-material/Handshake';
import FoodBankIcon from '@mui/icons-material/FoodBank';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import { useNavigate } from 'react-router-dom';
import { verify } from '../../utils/common';
import { ReactComponent as TransporteIcon } from '../../assets/svgs/transporte.svg';
import { ReactComponent as SeguroIcon } from '../../assets/svgs/seguro.svg';
import { ReactComponent as CajaIcon } from '../../assets/svgs/caja.svg';

const Services: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    }

    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [navigate]);
    
    return (
        <Container>
            <NavBar active="servicios"/>
            <ListService theme={theme}>
                <StyledBox theme={theme}>
                    <TransporteIcon style={{ width: '96px', height: '96px', cursor: 'pointer' }} />
                    <StyledTypography onClick={() => handleCardClick(12)} fontWeight="bold">Transporte de Personal</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <SeguroIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => handleCardClick(53)} fontWeight="bold">Seguro de Autos</StyledTypography>
                </StyledBox>
                <StyledBox theme={theme}>
                    <CajaIcon style={{width:'96px', height: '96px', cursor: 'pointer'}} />
                    <StyledTypography onClick={() => handleCardClick(11)} fontWeight="bold">Caja de Ahorro</StyledTypography>
                </StyledBox>

            </ListService>
        </Container>
    )
}

export default Services